<script>
    export let row = null;
</script>

{#if row && row.linked_issues.length && row.linked_issues[0].coding}
    {row.linked_issues[0].coding}
{/if}